
<template>
  <div class="home">
    <img class="top-banner" src="https://oss.pss.ink/outdoor/2022/12/30/20221230085208.png" alt="" srcset="">
    <div class="bottom-content">
      <!-- 登录框 -->
      <div class="log-card">
        <div class="input-box">
          <div class="border-bttom">
            <input class="tel-input input"  placeholder="请输入手机号"  v-model="phone" :maxlength="11" />
          </div>
          <div>
              <input class="code-input input"  placeholder="请输入验证码"   v-model="code" :maxlength="6" />
              <span class="code-btn"  @click="getCode">{{!timer?"获取验证码":`${second}秒`}}</span>
          </div>
        </div>
        <div class="submit-btn"  @click="login">确认领券</div>
      </div>
      <!-- 规则框 -->
      <div class="rule-box">
        <div class="ruleimg-box">
          <img class="ruleimg" src="https://oss.pss.ink/outdoor/2022/12/30/20221230085253.png" alt="" srcset=""/>
          <div class="ruleText-box">
            <p> 1.通过手机号登录领取优惠券后，请下单时使用相同的手机号进行登录。</p>
            <p>2.本优惠券分为金额劵及天数劵两类，金额劵可在下单租赁电源时抵扣一定的租赁金额，天数劵可在下单租赁电源时抵扣一定的租赁天数。</p>
            <p>3.优惠券仅在规定的时间内可使用，具体使用时间可点击具体的优惠券查看详情。</p>
            <p>4.若下单后取消订单，优惠券将返回至您的劵包内，下次下单时可再次使用。</p>
            <p>5.部分优惠劵若存在使用门槛的，需要消费满一定的天数或金额才能使用。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import {
		getSmsCode,
		register,
		phoneLoginAuth
	} from '@/api/user.js';
	import {
		validatePhone
	} from '@/utils/validate.js';
	import {
		setToken
	} from '@/utils/auth.js';
	import {
		Toast
	} from 'vant'

	export default {
		data() {
			return {
				phone: "",
				code: '',
				index: -1,
				timer: null,
				second: 0,
				businessId:null,
				checkedProtocol: false, // 勾选协议
				judage: false, //判断是登陆还是切换账号,
				phones: '', //当前使用手机号,
				currentBusniessData: undefined, //会员身份识别
				sourcePageUrl: '',
			}
		},
		created() {
			this.businessId = this.$route.query.businessId
		},
		methods: {
			//清空
			del() {
				this.phone = ""

			},
			//获取验证码
			getCode() {
				if (!this.timer) {
					this.second = 60;
					if (validatePhone(this.phone)) {

						getSmsCode({
							phone: this.phone
						}).then(res => {
							//console.log("aaa",res);
							this.timer = setInterval(() => {
								if (this.second == 0) {
									clearInterval(this.timer);
									this.timer = null;
									return false;
								}
								this.second--;
							}, 1000)
						})
					} else {
						Toast.fail("请输入正确的手机号")
					}
				}
			},
			login() {
				if (!validatePhone(this.phone)) {
					Toast.fail("请输入正确的手机号");
					return false;
				}
				if (!this.code) {
					Toast.fail("请输入正确的验证码");
					return false;
				}
				let params = {
					phone: this.phone,
					smsCode: this.code
				}
				const dotoast = Toast.loading({
				  message: '处理中...',	//加载的时候显示的文字
				  duration:0,		//展现时长(ms)，值为 0 时，toast 不会消失
				  overlay:true, 	//是否显示遮罩层
				  forbidClick: true	//是否禁止背景点击
				});
				phoneLoginAuth(params).then(res => {
					dotoast.clear()
					if (res.token) {
						this.$store.commit('user/SET_TOKEN', res.token)
						this.$store.commit('user/SET_MOBILE', params.phone)
						setToken(res.token)
						this.$router.push({
							path: '/',
							query: this.$route.query
						})
					}
					else{
						this.registerFunc(params)
					}			
				});

			},
			registerFunc(params){
				params.userName ='未设置昵称';
				params.type = '01';
				params.businessId = this.businessId
				register(params).then(res=>{		
					this.$store.commit('user/SET_TOKEN', res.token)
					this.$store.commit('user/SET_MOBILE', params.phone)
					setToken(res.token)
					this.$router.push({
						path: '/',
						query: this.$route.query
					})			
				});		
			}
		}
	}
</script>

<style lang="css" scoped>
.home{
  min-height: 100vh;
}
.top-banner{
  width: 100%;
  display: block;
}
.bottom-content{
  background: linear-gradient(180deg, #B3DF44 0%, #EAEF6E 100%);
  padding-bottom: 10px;
}
.log-card{
  margin: 0 14px;
  background: #9DC119;
  border-radius: 10px;
  padding: 14px;
}
.input-box{
  background-color: #fff;
  border: 1px solid #60A31B;
  border-radius: 10px;
  padding: 0 15px;
}
.border-bttom{
  border-bottom: 1px solid #EAEAEA;
}
.input{
  height: 50px;
  line-height: 50px;
  width: 100%;
  font-size: 15px;
  border: none;
  outline: none;
}
.code-input{
  width: 70%;
}
.code-btn{
  color: #000000;
  font-weight: bold;
  font-size: 15px;
}
.submit-btn{
  text-align: center;
  margin: 20px 0 0;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(180deg, #FFDB8D 0%, #FFC61E 100%);
  border-radius: 20px;
  font-weight: bold;
}
.rule-box{
  margin: 10px 14px;
  background: #9DC119;
  border-radius: 10px;
  padding: 14px;
}
.ruleimg-box{
  text-align: center;
}
.ruleimg{
  width: 62px;
}
.ruleText-box{
  color: #fff;
  font-size: 13px;
  text-align: left;
}
</style>